// extracted by mini-css-extract-plugin
export default {"recommendedProgramText":"RecommendedProgramV2_recommendedProgramText__HqRco"};